import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import { Card, CardText } from 'material-ui';
import _ from 'lodash';
import moment from 'moment';

import Translate from 'translate';

import IncmsService from 'services/IncmsService'
import { Text } from 'components/FormElements/';
import { toggleLoading } from 'stores/actions/';

class SearchComplaintModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      submitted: false
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.setState( { data: [], submitted: false } )
    }
  }

  submitForm( data ) {
    this.props.toggleLoading( true );

    let filterParams = {};
    _.map( data, ( value, filter ) => {
      if ( value ) filterParams[`filters[${filter}]`] = value;
    } );

    IncmsService.searchComplaint( data.complaintNumber ).then( ( response ) => {
      if ( response.data ) this.setState( { data: response.data, submitted: true } );
      else this.setState( { submitted: true } );
      this.props.toggleLoading( false );
    } )
  }

  render() {
    const { onSelectCard, onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="modal-search-incms col-md-8"
             open={open}
             onClose={() => {
               this.setState( { data: [] } );
               onClose()
             }}>
        <h5 className="mt-0"><Translate id="searchComplaint"/></h5>

        <Form onSubmit={this.submitForm}>
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm} className="mt-4">
              <div className="row mb-3">
                <div className="col-md-6">
                  <Text field="complaintNumber"
                        placeholder="imsreference"
                        className="form-control"/>
                </div>

              </div>



              <hr/>
              <div className="text-right">
                <button className="btn btn-info"
                        disabled={!getValue( 'complaintNumber' )}>
                  <Translate id="submit"/>
                </button>
              </div>
            </form>
          }
        </Form>

        <div className="row content mt-3">
            { this.state.submitted && this.state.data && this.state.data.result!==false &&

            <div key={1} className="col-md-6 mt-1 mb-3">

              <Card containerStyle={{ cursor: 'pointer' }} onClick={() => {
                onClose();
                
              }}>
                <CardText>
                  <div className="col-md-12 p-0">
                    
                    <div className="row">
                      <div className="col-md-3"><Translate id="complaintNumber"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.complaintNumber}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="accountNumber"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.accountNumber}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="accountName"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.accountName}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="status"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.status || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="phoneNumber"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.phoneNumber || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="creationDate"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.creationDate || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="resolutionDate"/></div>
                      <div className="col-md-9 text-small text-muted">{this.state.data.resolutionDate || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="incident"/></div>
                      <div
                        className="col-md-9 text-small text-muted">{this.state.data.incident || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="incidentCause"/></div>
                      <div
                        className="col-md-9 text-small text-muted">{this.state.data.incidentCause || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="incidentDescription"/></div>
                      <div
                        className="col-md-9 text-small text-muted">{this.state.data.incidentDescription || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="substation"/></div>
                      <div className="col-md-9 text-small text-muted">
                        {this.state.data.substation ? `${this.state.data.substation}` : '---'}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="feeder"/></div>
                      <div className="col-md-9 text-small text-muted">
                        {this.state.data.feeder ? `${this.state.data.feeder}` : '---'}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="observations"/></div>
                      <div className="col-md-9 text-small text-muted">
                        <div>
                            { this.state.data.incidentObservations && _.map( this.state.data.incidentObservations, ( itemOb, indexOb ) =>
                            <div key={indexOb*9293}> { moment(itemOb.entryDate , "DD-MM-YYYY hh:mm:ss" ).format( 'DD/MM/YYYY' ) }: {itemOb.description} </div>
                           ) }
                        </div>

                      </div>
                    </div>
                  </div>
                </CardText>
              </Card>
            
            </div>
            }
          { this.state.submitted && this.state.data && this.state.data.result===false &&
          <div className="col-md-12 text-center">
            <h5 className="text-muted mt-0"><Translate id="noDataFound"/></h5>
          </div>
          }
        </div>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( SearchComplaintModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SearchComplaintModal/index.js